var _dec, _class, _ColHeader;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { omitProps, callRenderProp } from '@instructure/ui-react-utils';
import { IconMiniArrowUpLine, IconMiniArrowDownLine, IconMiniArrowDoubleLine } from '@instructure/ui-icons';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { allowedProps, propTypes } from './props';

/**
---
parent: Table
id: Table.ColHeader
---
**/
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
let ColHeader = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_ColHeader = class ColHeader extends Component {
  constructor(...args) {
    super(...args);
    this.handleClick = event => {
      const _this$props = this.props,
        id = _this$props.id,
        onRequestSort = _this$props.onRequestSort;
      onRequestSort && onRequestSort(event, {
        id
      });
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props2;
    (_this$props$makeStyle = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props2);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props3;
    (_this$props$makeStyle2 = (_this$props3 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props3);
  }
  renderSortArrow() {
    const _this$props4 = this.props,
      sortDirection = _this$props4.sortDirection,
      onRequestSort = _this$props4.onRequestSort,
      styles = _this$props4.styles;
    if (sortDirection === 'ascending') {
      return _jsx(IconMiniArrowUpLine, {
        css: styles === null || styles === void 0 ? void 0 : styles.sortedIconColor
      });
    }
    if (sortDirection === 'descending') {
      return _jsx(IconMiniArrowDownLine, {
        css: styles === null || styles === void 0 ? void 0 : styles.sortedIconColor
      });
    }
    if (onRequestSort) {
      return _jsx(IconMiniArrowDoubleLine, {
        css: styles === null || styles === void 0 ? void 0 : styles.unSortedIconColor
      });
    }
    return void 0;
  }
  render() {
    const _this$props5 = this.props,
      onRequestSort = _this$props5.onRequestSort,
      width = _this$props5.width,
      children = _this$props5.children,
      sortDirection = _this$props5.sortDirection,
      scope = _this$props5.scope,
      styles = _this$props5.styles;
    return _jsxs("th", {
      ...omitProps(this.props, ColHeader.allowedProps),
      css: styles === null || styles === void 0 ? void 0 : styles.colHeader,
      style: {
        width
      },
      scope: scope,
      "aria-sort": sortDirection,
      children: [onRequestSort && _jsx("button", {
        onClick: this.handleClick,
        css: styles === null || styles === void 0 ? void 0 : styles.button,
        children: _jsxs("div", {
          css: styles === null || styles === void 0 ? void 0 : styles.buttonContent,
          children: [callRenderProp(children), this.renderSortArrow()]
        })
      }), !onRequestSort && children, !onRequestSort && this.renderSortArrow()]
    });
  }
}, _ColHeader.displayName = "ColHeader", _ColHeader.componentId = 'Table.ColHeader', _ColHeader.allowedProps = allowedProps, _ColHeader.propTypes = propTypes, _ColHeader.defaultProps = {
  textAlign: 'start',
  sortDirection: 'none',
  children: null,
  scope: 'col'
}, _ColHeader)) || _class);
export default ColHeader;
export { ColHeader };